import { AnyAction, applyMiddleware, combineReducers, compose, createStore, Store, StoreEnhancer } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';
import reducers from '@wfp-root-app/store/reducers';
import { BlockUiMiddleware } from 'react-block-ui/redux';
import { createSelectorHook, TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import State from '@wfp-root-app/store/state';

import errorMiddleware from '../../utils/errorMiddleware';
import loadingMiddleware from '../../utils/loadingMiddleware';

const composeEnhancers =
    process.env.NODE_ENV === 'development'
        ? (window as Window & { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose })
              .__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
        : compose;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const enhancer: StoreEnhancer<any> = composeEnhancers(
    applyMiddleware(loadingMiddleware, errorMiddleware, thunk, BlockUiMiddleware)
);
export const store = createStore(combineReducers(reducers), enhancer);

export type RootAppState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootAppState, unknown, AnyAction>;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootAppState> = useSelector;

export const dispatch = store.dispatch as ThunkDispatch<Store<RootAppState>, void, AnyAction>;

export const useStoreSelector: TypedUseSelectorHook<State> = createSelectorHook();
